export function emailInviteHTML(toName, toEmail, fromName, yardName) {
  return `
  <!DOCTYPE html>
<html>
<head>
    <title></title>
    <meta http-equiv="Content-Type" content="text/html; charset=utf-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1">
    <meta http-equiv="X-UA-Compatible" content="IE=edge" />
    <style type="text/css">
        /* CLIENT-SPECIFIC STYLES */
        body, table, td, a { -webkit-text-size-adjust: 100%; -ms-text-size-adjust: 100%; }
        table, td { mso-table-lspace: 0pt; mso-table-rspace: 0pt; }
        img { -ms-interpolation-mode: bicubic; }
        /* RESET STYLES */
        img { border: 0; height: auto; line-height: 100%; outline: none; text-decoration: none; }
        table { border-collapse: collapse !important; }
        body { height: 100% !important; margin: 0 !important; padding: 0 !important; width: 100% !important; }
        /* iOS BLUE LINKS */
        a[x-apple-data-detectors] {
            color: inherit !important;
            text-decoration: none !important;
            font-size: inherit !important;
            font-family: inherit !important;
            font-weight: inherit !important;
            line-height: inherit !important;
        }
        .em_header a {
            color:#76798a;
            text-decoration:none;
        }
        .em_blk a {
            color:#333333;
            text-decoration:none;
        }
        .em_grayfooter a {
            color:#FFFFFF;
            text-decoration:none;
        }
        .em_wht a {
            color:#ffffff;
            text-decoration:none;
        }
        @media screen and (min-width: 601px) {
            .container {
                width: 600px !important;
            }
        }
        /* MOBILE STYLES */
        @media screen and (max-width:600px){
            .em_wrapper {
                width:100% !important;
            }
            .em_pad {
                padding:40px 15px 40px 15px !important;
            }
            .em_p15 {
                padding-bottom:15px !important;
            }
            .em_p25 {
                padding-bottom:25px !important;
            }
            .em_p40 {
                padding-bottom:40px !important;
            }
            .em_pad_1 {
                padding: 0px 15px 10px 15px !important;
            }
            .em_pad_2 {
                padding: 0px 15px 40px 15px !important
            }
            .em_brk {
                display:block !important;
            }
            .em_hide {
                display:none !important;
            }
            .em_center {
                text-align:center !important;
            }
            .BodyCopy {
                font-size: 18px !important;
                line-height: 24px !important;
            }


            /* BR STYLES */

            .em_d20 {
                height: 20px;
            }

            .em_d40 {
                height: 40px;
            }

            .img-max {
                width: 100% !important;
                max-width: 100% !important;
                height: auto !important;
            }

            .mobile-first {display: table-header-group !important;}
            .mobile-intermediate {display: table-row !important;}
            .mobile-last {display: table-footer-group !important;}

            .mobile-center {
                display: table !important;
                float: none;
                margin-left: auto !important;
                margin-right: auto !important;
            }

            .mobile-full-width {
                display: table;
                width: 100%;
            }

            .mobile-cta {
                padding: 20px 25px !important;
                font-size:14px !important;
            }
            .mobile-padding {
                padding-left: 5px !important;
                padding-right: 5px !important;
            }
        }
        /* ANDROID CENTER FIX */
        div[style*="margin: 14px 0;"] { margin: 0 !important; }
    </style>
</head>
<body style="background-color: #DDDDDD; margin: 0 !important; padding: 0 !important;">
	<table align="center" border="0" cellpadding="0" cellspacing="0" width="100%">
    <tbody>
    <tr>
        <td align="center" valign="top"><!--[if (gte mso 9)|(IE)]>
            <table align="center" border="0" cellspacing="0" cellpadding="0" width="600">
                <tr>
                    <td align="center" valign="top" width="600">
            <![endif]-->
            <table align="center" border="0" cellpadding="0" cellspacing="0" class="container" style="max-width:600px;" width="100%"><!-- Navigation -->
                <tbody>
                <tr>
                    <td align="center" valign="top"><!--[if (gte mso 9)|(IE)]>
                        <table align="center" border="0" cellspacing="0" cellpadding="0" width="600">
                            <tr>
                                <td align="center" valign="top" width="600">
                        <![endif]-->
                        <table align="center" border="0" cellpadding="0" cellspacing="0" style="max-width:600px;" width="100%">
                            <tbody>
                            <tr>
                                <td align="left" bgcolor="#FFFFFF" style="font-size:0; padding-top:0px;" valign="top" class=""><!--[if (gte mso 9)|(IE)]>
                                    <table align="center" border="0" cellspacing="0" cellpadding="0" width="600">
                                        <tr>
                                            <td align="left" valign="top" width="600">
                                    <![endif]-->
                                    <div style="display:inline-block; max-width:600px; vertical-align:top; width:100%;">
                                        <table align="left" bgcolor="#2d8cff" border="0" cellpadding="0" cellspacing="0" width="100%">
                                            <tbody>
                                            <tr style="background:#2d8cff;">
                                                <td align="left" style="padding: 15px 30px" valign="middle" class="">
													<a href="https://transloads.co/" style="text-decoration:none;" target="_blank" rel="noopener noreferrer">
														<img alt="transloads.co" border="0" style="display:block; max-width: 256px; max-height: 56px;; width:100%;" width="256" src="https://app.transloads.co/logo_transloads_white.png" />
													</a>
												</td>
                                            </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                        <!--[if (gte mso 9)|(IE)]>
                        </td>
                        </tr>
                        </table>
                        <![endif]--></td>
                </tr>

				<!-- Body -->
                <tr>
                    <td class="mobile-padding" align="center" bgcolor="#FFFFFF" style="padding:0px 30px 30px 30px;" valign="top">
                        <table align="center" border="0" cellpadding="0" cellspacing="0" style="max-width:600px;" width="100%">
							<!-- CTA -->
                            <tbody>
                            <tr>
                                <td align="center" class="BodyCopy" style="padding-bottom: 60px; font-family: Helvetica, sans-serif; font-size:16px; line-height:32px; color:#FFFFFF; font-weight:400; color:#232333; letter-spacing: .01em; text-align: center;">
									<div style="max-width:512px; margin:10px auto;">
									<!-- htmlContent -->
                  <!-- Begin HTML Content -->
                        <h1> ${toName}, <br><br> Welcome to transloads.co! <br></h1>
                        <hr style="background:#2d8cff; height: 8px; width: 60px; border-style: solid; border-color: #095484; border-width: 1px 0 0 0; border-radius: 8px;" />
                        <br><br>
                        ${fromName} at ${yardName} is inviting you to join transloads.co.
                        To create your account, please click on the button below and register using this email address: <br>
                        ${toEmail} <br>
                        Once your account is activated, you will have full access to the Yard Management System.
                        <br><br><br>
                        <table bgcolor="#FF5F0F" style="border-radius:3px; border-spacing:0; margin:0 auto">
                            <tbody>
                                <tr style="background:#FF5F0F;">
                                    <td class="mobile-cta" style="border: 0 solid #FF5F0F;  display: inline-block; padding: 20px 45px; text-align: center; font-family:'Lato', Helvetica, sans-serif; font-size:15px; line-height:24px; color:#FFFFFF; font-weight:900; text-decoration: none; text-transform: uppercase; letter-spacing: .2em">
                                        <a href="https://app.transloads.co/?signUp"
                                            target="_blank"
                                            rel="noreferrer"
                                            style="color:#FFFFFF; text-decoration:none;"
                                        >
                                            CREATE ACCOUNT
                                        </a>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <br><br>
                        <hr style="border-bottom:#CCCCCC 6px dotted; border-width: 0 0 6px 0;">
                        <br>
                        Button not working? Try pasting this URL into your browser: <br>
                        <strong>
                            <a href="https://app.transloads.co/?signUp"
                                target="_blank"
                                rel="noreferrer"
                                style="color: #2d8cff; text-decoration:none; word-break: break-all;"
                            >
                                https://app.transloads.co/?signUp
                            </a>
                        </strong>
                        <!-- End HTML Content -->

									<!-- End htmContent -->
									</div>
								</td>
                            </tr>
                            </tbody>
                            <!-- End CTA -->
                        </table>
                    </td>
                </tr>
                <!--END Body-->

                </tbody>
            </table>
            <!--[if (gte mso 9)|(IE)]>
            </td>
            </tr>
            </table>
            <![endif]--></td>
    </tr>
    </tbody>
	</table>
</body>
</html> `;
}
